import * as React from 'react';
var BodyContext = React.createContext(null);
export default BodyContext;